import { fetchSameOrigin } from '../Utils';

const addDependent = (memberId, groupId = undefined) => {
  const body = JSON.stringify({
    deep_link_path: "/my_family/overview?type=dependents",
    active_benefit_id: groupId,
  });

  return fetchSameOrigin(`/members/${memberId}/impersonate`, 'POST', { body })
    .then(r => r.json())
    .then(response => {
      window.open(response.impersonation_url);
      return true;
    });
};

export default addDependent;
